import { isValueFalsey } from '../../internal';
import { requiredErrorState } from '../utils';
export const isRequiredRule = (params, value) => {
  let hasValue = true;
  if (params.required && (isValueFalsey(value) || Array.isArray(value) && value.length === 0)) {
    hasValue = false;
  }
  return {
    triggered: !hasValue,
    validationState: {
      isValid: hasValue,
      message: !hasValue ? params.customErrorMessages?.isRequired || requiredErrorState(params.label).message : undefined,
      type: hasValue ? undefined : 'error',
      messageKey: 'isRequired'
    }
  };
};